import { create } from "zustand";
import { getToken, setToken, clearToken } from "../lib/auth";

const API_BASE = import.meta.env.VITE_API_URL ?? "/api";

interface AuthState {
  authenticated: boolean;
  loading: boolean;
  initialize: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  authenticated: false,
  loading: true,

  initialize: async () => {
    const token = getToken();
    if (!token) {
      set({ authenticated: false, loading: false });
      return;
    }
    try {
      const res = await fetch(`${API_BASE}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        set({ authenticated: true, loading: false });
      } else {
        clearToken();
        set({ authenticated: false, loading: false });
      }
    } catch {
      clearToken();
      set({ authenticated: false, loading: false });
    }
  },

  login: async (email: string, password: string) => {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const body = await res.json();
    if (!res.ok) throw new Error(body.error ?? "Login failed");
    setToken(body.token);
    set({ authenticated: true });
  },

  signOut: () => {
    clearToken();
    set({ authenticated: false });
  },
}));
